import { Alert } from "@kyan/ui";

import { useDowngradedPerformanceController } from "./DowngradedPerformance.controller";

export const DowngradedPerformance: React.FC = () => {
  const { isInvisible, dismiss } = useDowngradedPerformanceController();

  if (isInvisible) return null;

  return (
    <Alert
      className="p-4"
      variant="notice"
      title="Account state data may be delayed."
      description="Our servers are healthy, but dashboard data is updating slower than usual. This does not affect trading or account safety."
      closeIconProps={{
        onClick: dismiss,
      }}
    />
  );
};
